import { connect } from 'react-redux';
import { getToken } from 'datamodel/Auth/selectors';
import { getUserId, getDefaultPicture } from 'datamodel/User/selectors';
import {
  AUTHENTICATION_FORM_MODE,
  openAuthenticationModal,
} from 'app/Sections/auth/forms/authentication-form';
import { modal, MODAL_ID } from 'containers/ReduxModal/emitter';
import ImpulsaLanding from './impulsa-landing';

const mapStateToProps = (state) => ({
  token: getToken(state),
  picture: getDefaultPicture(state),
  isLoggedIn: !!getUserId(state),
});

const mapDispatchToProps = {
  loginHandler: () => {
    const handleClose = () => {
      modal.remove(MODAL_ID.AUTH);
    };

    openAuthenticationModal({
      mode: AUTHENTICATION_FORM_MODE.LOGIN,
      onSuccess: () => {},
      onClose: handleClose,
    });
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(ImpulsaLanding);
